import { render, staticRenderFns } from "./cara-pemesanan.vue?vue&type=template&id=e3a02e4a&scoped=true&"
import script from "./cara-pemesanan.vue?vue&type=script&lang=ts&"
export * from "./cara-pemesanan.vue?vue&type=script&lang=ts&"
import style0 from "./cara-pemesanan.vue?vue&type=style&index=0&id=e3a02e4a&prod&lang=scss&scoped=true&"
import style1 from "./cara-pemesanan.vue?vue&type=style&index=1&id=e3a02e4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a02e4a",
  null
  
)

export default component.exports